import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dc-modal',
  templateUrl: './dc-modal.component.html',
  styleUrls: ['./dc-modal.component.scss'],
})
export class DcModalComponent implements OnInit {
  public title = null;
  public body = null;
  public action = null;
  public positive = null;
  public negative = null;
  public link = null;
  public close = null;
  public selectLabel = null;
  public selectOptions = [];
  actionLink = null;
  actionWindow = null;
  form: UntypedFormGroup;

  constructor(
    public modal: NgbActiveModal,
    private fb: UntypedFormBuilder,
  ) {
    this.form = this.fb.group({
      select: [null, Validators.required],
    });
   }

  ngOnInit(): void {
  }

  setDialogProps(props: any) {
    this.title = props.title || '';
    this.body = props.body || '';
    this.action = props.buttons.action || null;
    this.positive = props.buttons.positive || null;
    this.negative = props.buttons.negative || null;
    this.close = props.buttons.close || null;
    this.actionLink = props.buttons.actionLink || null;
    this.actionWindow = props.buttons.actionWindow || null;
    this.selectLabel = props.selectLabel || null;
    this.selectOptions = props.selectOptions || [];
  }

  onAction(action: any) {
    if (this.selectOptions.length) {
      if (action.positive == 1) {
        if (this.form.valid) {
          this.modal.close({ selected: this.form.value.select });
        }
      } else {
        this.modal.close(JSON.stringify(action));
      }
    } else {
      if (action.action == 1) {
        if (this.actionLink !== null) {
          window.open(this.actionLink, this.actionWindow);
        }
      } else {
        this.modal.close(JSON.stringify(action));
      }
    }
  }
}
